import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    EmailID: "",
    Phone_Number: "",
    image_url: "",
    getPreviousRoute: "",
    MotoristName: {},
    CarDetails: {},
    Authentication: false,
    MotoristBoolean: true,
    isSubscribed: false,
    view_motorist_profile: false,
    current_location: true,
    current_chat_id: "",

    getIssueDetails: {},
    currentFormObject: {},
    currentRouteObject: {},
    ChatListings: {},
    CompleteData: {},

    GetCurrentUser: {},
    GetCurrentOrg: [],
    GetTeamList: [],

    Enabled_Location: false,
    audioAutoPlay: true,
  },
  getters: {
    get_auth: (state) => {
      return state.Authentication;
    },
    get_user_email: (state) => {
      return state.EmailID;
    },
    get_phone_number: (state) => {
      return state.Phone_Number;
    },
    get_current_user_details: (state) => {
      return state.GetCurrentUser;
    },
    get_motorist_name: (state) => {
      return state.MotoristName;
    },
    get_car_details: (state) => {
      return state.CarDetails;
    },
    get_chat_list: (state) => {
      return state.ChatListings;
    },
    get_motorist_again: (state) => {
      return state.MotoristBoolean;
    },
    get_subscription_status: (state) => {
      return state.isSubscribed;
    },
    get_chat_id: (state) => {
      return state.current_chat_id;
    },
    get_motorist_boolean: (state) => {
      return state.view_motorist_profile;
    },
    get_current_location: (state) => {
      return state.current_location;
    },
    get_complete_data: (state) => {
      return state.CompleteData;
    },
    get_location_enabled: (state) => {
      return state.Enabled_Location;
    },
    get_audio_autoplay: (state) => {
      return state.audioAutoPlay;
    },
  },
  mutations: {
    SET_AUTH(state, Authentication) {
      state.Authentication = Authentication;
    },
    SET_USEREMAIL(state, username) {
      state.EmailID = username;
    },
    SET_PHONENUMBER(state, phone_number) {
      state.Phone_Number = phone_number;
    },
    SET_CURRENTUSER_DETAILS(state, GetCurrentUserDetails) {
      state.GetCurrentUser = GetCurrentUserDetails;
    },
    SET_MOTORIST_NAME(state, MotoristName) {
      state.MotoristName = MotoristName;
    },
    SET_CAR_DETAILS(state, CarDetails) {
      state.CarDetails = CarDetails;
    },
    SET_CHAT_LIST(state, ChatListings) {
      state.ChatListings = ChatListings;
    },
    SET_MOTORIST_AGAIN(state, MotoristBoolean) {
      state.MotoristBoolean = MotoristBoolean;
    },
    SET_SUBSCRIPTION_STATUS(state, isSubscribed) {
      state.isSubscribed = isSubscribed;
    },
    SET_CHAT_ID(state, current_chat_id) {
      state.current_chat_id = current_chat_id;
    },
    SET_MOTORIST_BOOLEAN(state, view_motorist_profile) {
      state.view_motorist_profile = view_motorist_profile;
    },
    SET_CURRENT_LOCATION(state, current_location) {
      state.current_location = current_location;
    },
    SET_COMPLETE_DATA(state, CompleteData) {
      if (Object.keys(CompleteData).length === 0) {
        state.CompleteData = {};
      } else {
        state.CompleteData = {
          ...state.CompleteData,
          ...CompleteData,
        };
      }
    },
    SET_LOCATION_ENABLED(state, Enabled_Location) {
      state.Enabled_Location = Enabled_Location;
    },
    SET_AUDIO_AUTOPLAY(state, audioAutoPlay) {
      state.audioAutoPlay = audioAutoPlay;
    },
  },
  actions: {
    clearMotoristAndCarDetails({ commit }) {
      commit("SET_MOTORIST_BOOLEAN", false);
      commit("SET_SUBSCRIPTION_STATUS", false);
      commit("SET_CURRENT_LOCATION", true);
      commit("SET_CAR_DETAILS", {});
      commit("SET_CURRENT_LOCATION", false);
      // commit("SET_MOTORIST_AGAIN", true);
      // commit("SET_CHAT_LIST", {});
      // commit("SET_CHAT_ID", "");
    },
  },
  modules: {},
  plugins: [createPersistedState()],
});

// window.addEventListener("beforeunload", function () {
//   store.dispatch("clearMotoristAndCarDetails");
// });

// window.addEventListener("beforeunload", (event) => {
//   if (performance.navigation.type === performance.navigation.TYPE_RELOAD) {
//     console.log("Page is being reloaded");
//   } else {
//     store.dispatch("clearMotoristAndCarDetails");
//   }
// });

function onUnload() {
  localStorage.setItem("tabClosedAt", Date.now());
}
async function onLoad() {
  const tabClosedAt = parseInt(localStorage.getItem("tabClosedAt"), 10);
  const currentTime = Date.now();

  const timeDifference = currentTime - tabClosedAt;

  if (timeDifference > 10000) {
    console.log("Detected tab closure and reopening");
    store.dispatch("clearMotoristAndCarDetails");

    localStorage.removeItem("tabClosedAt");
  }
}
window.addEventListener("unload", onUnload);
window.addEventListener("load", onLoad);

export default store;
